import React from 'react';
import { Box, Typography } from '@mui/material';
import CardGiftcardIcon from '@mui/icons-material/CardGiftcard';

interface BonusNoticeProps {
  title: string;
  description?: string | null;
  terms?: string | null;
  /** When set, the bonus is not yet earned: e.g. "12-month contract". */
  needs?: string | null;
}

/** Bonus extra from a promo code (e.g. a gift voucher), with its optional terms and conditions. */
export default function BonusNotice({ title, description, terms, needs }: BonusNoticeProps) {
  const earned = !needs;
  return (
    <Box
      sx={{
        p: 1.5,
        borderRadius: 1.5,
        border: '1px solid',
        borderColor: earned ? 'primary.light' : 'warning.light',
        bgcolor: earned ? 'rgba(59,158,255,0.06)' : 'rgba(255,167,38,0.08)',
        textAlign: 'left',
      }}
    >
      <Box sx={{ display: 'flex', alignItems: 'center', gap: 1 }}>
        <CardGiftcardIcon fontSize="small" color={earned ? 'primary' : 'warning'} />
        <Typography variant="body2" fontWeight={700}>
          {earned ? `Bonus included: ${title}` : `Choose a ${needs} to receive: ${title}`}
        </Typography>
      </Box>
      {description && (
        <Typography variant="body2" sx={{ mt: 0.5 }}>
          {description}
        </Typography>
      )}
      {terms && (
        <Box sx={{ mt: 1 }}>
          <Typography variant="caption" fontWeight={700} display="block">
            Bonus terms and conditions
          </Typography>
          <Typography variant="caption" color="text.secondary" sx={{ whiteSpace: 'pre-line' }}>
            {terms}
          </Typography>
        </Box>
      )}
    </Box>
  );
}
